import React from 'react';

const Logo = (props) => {
  return (
    <img
      alt="Logo"
      src="/static/logo_title.png"
      width="160"
      {...props}
    />
  );
};

export default Logo;
